import { Box, Card } from '@radix-ui/themes';
import { LoginForm } from './ui';

export function Login() {
  return (
    <Box className="flex items-center justify-center w-full h-screen">
      <Card className="min-w-[300px] max-w-[400px] p-4 shadow-lg">
        <LoginForm />
      </Card>
    </Box>
  );
}
